import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import users from '../../assets/users.jpg';
import events from '../../assets/events.jpg';
import exhibitors from '../../assets/exhibitors.jpg';

const HomeRoot = () => {
	const { t } = useTranslation();
    const navigate = useNavigate();

	return (
    <div>
		<h1>{t('home.title')}</h1>
        <p>{t('home.subtitle_root')}</p>
		<div className='grid'>
			<div className='item' onClick={() => navigate('/cabinet/userlist')}>
                <img className='icon' alt='users' src={users}/>
                <div className='text'>
                    {t('home.users')}
                </div>
            </div>
			<div className='item' onClick={() => navigate('/cabinet/eventlist')}>
                <img className='icon' alt='events' src={events}/>
                <div className='text'>
                    {t('home.events')}
                </div>
            </div>
			<div className='item' onClick={() => navigate('/cabinet/exhibitorlist')}>
                <img className='icon' alt='exhibitors' src={exhibitors}/>
                <div className='text'>
                    {t('home.exhibitors')}
                </div>
            </div>
		</div>
    </div>
	);
};

export default HomeRoot;
